
<!-- Counter Start -->
<section class="section counter-bg" style="background: url(assets/images/counter-bg-1.jpg) center center">
    <div class="bg-overlay op-75"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6">
                <div class="text-center mb-5">
                    <h2 class="font-weight-normal text-white mb-2">Hemos completado</h2>
                    <h5 class="font-weight-normal text-white-70">Más 40 proyectos de forma exitosa</h5>
                </div>
            </div>
        </div>
        <div class="row" id="counter">
            <div class="col-lg-4 col-md-6">
                <div class="counter-box text-center text-white mb-4 mb-lg-0">
                    <i class="pe-7s-like2 counter-icon mb-4"></i>
                    <h2 class="mb-2 font-weight-normal"><span class="counter-value mt-4" [CountTo]="40" [from]="0" [duration]="1"></span>+</h2>
                    <p class="mb-0 text-white-70 text-uppercase f-14">Proyectos Exitosos</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="counter-box text-center text-white mb-4 mb-lg-0">
                    <i class="pe-7s-light counter-icon mb-4"></i>
                    <h2 class="mb-2 font-weight-normal"><span class="counter-value mt-4" [CountTo]="90" [from]="0"
                        [duration]="1"></span>+</h2>
                    <p class="mb-0 text-white-70 text-uppercase f-14">Ideas de proyectos</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="counter-box text-center text-white mb-4 mb-lg-0">
                    <i class="pe-7s-smile counter-icon mb-4"></i>
                    <h2 class="mb-2 font-weight-normal"><span class="counter-value mt-4" [CountTo]="30" [from]="0"
                        [duration]="1"></span>+</h2>
                    <p class="mb-0 text-white-70 text-uppercase f-14">Clientes satisfechos</p>
                </div>
            </div>
            <!-- <div class="col-lg-3 col-md-6">
                <div class="counter-box text-center text-white mb-4 mb-lg-0">
                    <i class="pe-7s-star counter-icon mb-4"></i>
                    <h2 class="mb-2 font-weight-normal"><span class="counter-value mt-4" [CountTo]="50" [from]="0"
                        [duration]="1"></span></h2>
                    <p class="mb-0 text-white-70 text-uppercase f-14"></p>
                </div>
            </div> -->
        </div>
    </div>
</section>
<!-- Counter End -->